<template>
  <div class="item">
    <div class="item-parent" v-if="winnerName">
      <p>
        {{ winnerName }}
        <span>{{ winnerScore }}</span>
      </p>
    </div>

    <div class="item-childrens">
      <div
        class="item-child"
        v-bind:class="{ 'winner-child': !winnerName }"
        v-for="(child, index) in children"
        :key="`${child.name}-${index}`"
      >
        <p v-if="!child.children">
          {{ child.name }}
          <span>{{ child.score }}</span>
        </p>
        <BracketItem v-else :winnerName="child.name" :children="child.children" :winnerScore="child.score"></BracketItem>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BracketItem",
  props: {
    winnerName: {
      type: String,
      required: false,
    },
    children: {
      type: Array,
      required: true,
    },
    winnerScore: {
      type: Number,
      required: false,
    },
  },
  components: {
    BracketItem: {
      extends: "BracketItem",
    },
  },
};
</script>
